import script from "./LegalNoticesView.vue?vue&type=script&setup=true&lang=js"
export * from "./LegalNoticesView.vue?vue&type=script&setup=true&lang=js"

import "./LegalNoticesView.vue?vue&type=style&index=0&id=446adb42&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-446adb42"]])

export default __exports__